import { create } from 'zustand'
import type { VolatilityViewEntry } from '@/services/mappers/volatilityMapper'

export interface VolatilityFiltersState {
  startDate?: string
  endDate?: string
  assetTypes: string[]
  swingThresholdPct?: number
}

interface PriceVolatilityState {
  filters: VolatilityFiltersState
  entries: VolatilityViewEntry[]
  setFilters: (filters: Partial<VolatilityFiltersState>) => void
  resetFilters: () => void
  setEntries: (entries: VolatilityViewEntry[]) => void
}

const defaultFilters: VolatilityFiltersState = {
  assetTypes: [],
}

export const usePriceVolatilityStore = create<PriceVolatilityState>((set) => ({
  filters: defaultFilters,
  entries: [],
  setFilters: (filters) =>
    set((state) => ({
      filters: { ...state.filters, ...filters },
    })),
  resetFilters: () => set({ filters: defaultFilters }),
  setEntries: (entries) => set({ entries }),
}))
